import type { VariantProps } from "@gluestack-ui/utils/nativewind-utils";
import React from "react";
import { hstackStyle } from "./styles";

type IHStackProps = React.ComponentPropsWithoutRef<"div"> &
  VariantProps<typeof hstackStyle>;

const HStack = React.forwardRef<React.ComponentRef<"div">, IHStackProps>(
  ({ className, space, reversed, flexSpace, ...props }, ref) => {
    return (
      <div
        className={hstackStyle({
          space,
          reversed,
          flexSpace,
          class: className,
        })}
        {...props}
        ref={ref}
      />
    );
  },
);

HStack.displayName = "HStack";

export { HStack };
